import React, { useState } from 'react';
import FilterSearch from './filters/FilterSearch';
import FilterSearchSelect from './filters/FilterSearchSelect';
import FilterRangeSlider from './filters/FilterRangeSlider';
import FilterCheckbox from './filters/FilterCheckbox';
import FilterSelect from './filters/FilterSelect';
import FilterAccordionMultiSelect from './filters/FilterAccordionMultiSelect';
import FilterAccordionSingleSelect from './filters/FilterAccordionSingleSelect';
import FilterButtonGroup from './filters/FilterButtonGroup';
import FilterOrderBy from './filters/FilterOrderBy';
import FilterDate from './filters/FilterDate';
import FilterIcon from '../assets/images/icons/FilterIcon.svgr';
import CloseIcon from '../assets/images/icons/CloseIcon.svgr';

function sidebar(props) {
  const [modalVisible, setModalVisible] = useState(false);

  const {
    layout,
    filters,
    results,
    currentSearchTerm,
    selected,
    mobileStyle,
    displayPostCounts,
    order,
    autoLoadFilters,
    filterReset,
    sidebarLeft,
    sidebarRight,
    displayReset,
    displayResults,
    displaySort,
    displaySearch,
    postType,
    orderChange,
    toggleSelected,
    replaceSelected,
    addToSelected,
    isSelected,
    resetSelected,
    searchFieldChange,
    setCurrentPage,
    setChangedFilter,
    setFilterReset,
  } = props;

  const className = props.className ? props.className : '';

  const components = {
    'search-select': FilterSearchSelect,
    'range-slider': FilterRangeSlider,
    'checkbox': FilterCheckbox,
    'select': FilterSelect,
    'button-group': FilterButtonGroup,
    'accordion-multi-select': FilterAccordionMultiSelect,
    'accordion-single-select': FilterAccordionSingleSelect,
    'date': FilterDate
  }

  const filterList = autoLoadFilters ? [] : props.children;
  let modalClose;
  let modalOpen;
  let applyFilters;
  let contentLeft;
  let contentRight;
  let sidebarDetail;
  let reset;
  let totalResults;
  let searchComponent;
  let sortComponent;
  let filterType;
  let modalTop;
  let resultsElement;
  let resultsText;
  let sidebarReset;

  function toggleModal(e) {
    e.preventDefault();
    setModalVisible(!modalVisible);
  }

  function modalActiveClass() {
    let modalClassString = '';
    document.body.style.overflow = '';
    if (modalVisible) {
      modalClassString = 'modal-active';
      document.body.style.overflow = 'hidden';
    }

    return modalClassString;
  }

  if (Object.entries(filters).length !== 0 && autoLoadFilters) {
    let i = 0;
    for (const taxonomy in filters) {
      const type = filters[taxonomy].type;
      const TheFilter = components[type];

      filterList.push(
        <TheFilter
          key={i++}
          label={filters[taxonomy].label}
          labelTitle={filters[taxonomy].labelTitle}
          taxonomy={filters[taxonomy].terms}
          taxSlug={taxonomy}
          selected={selected}
          displayPostCounts={displayPostCounts}
          collapsible={filters[taxonomy].collapsible}
          scrollable={filters[taxonomy].scrollable}
          dropdown={filters[taxonomy].dropdown}
          filterReset={filterReset}
          labelTitle={filters[taxonomy].labelTitle}
          resetSelected={resetSelected}
          toggleSelected={toggleSelected}
          replaceSelected={replaceSelected}
          addToSelected={addToSelected}
          isSelected={isSelected}
          setCurrentPage={setCurrentPage}
          setChangedFilter={setChangedFilter}
          setFilterReset={setFilterReset}
          tooltip={filters[taxonomy].tooltip}
          tooltipLeftContent={filters[taxonomy].tooltipLeftContent}
          tooltipRightContent={filters[taxonomy].tooltipRightContent}
          mobileStyle={mobileStyle}
        ></TheFilter>
      );
    }
  }

  if (displayReset) {
    reset = <a className="btn-filter-action btn-reset" onClick={() => { resetSelected() }}><span>Reset Filters</span></a>
  }

  if (displayReset && layout === 'programs') {
    sidebarReset = <div className="eight29-sidebar-reset">
      {reset}
    </div>
  }

  if (results === 1) {
    resultsText = ' Result';
  } else {
    resultsText = ' Results';
  }

  resultsElement = <p className='posts-list__count'>
    {results}{resultsText}
  </p>

if (postType && postType != "undefined") {
  filterType = postType.charAt(0).toUpperCase() + postType.slice(1)
}

  if (mobileStyle === 'modal') {
    modalClose = <button
    className="eight29-sidebar-toggle eight29-sidebar-close"
    onClick={(e) => { toggleModal(e) }}
  >
  </button>
    modalTop = <div className="modal-top">
      <p>Filter {filterType}</p>
      {modalClose}
    </div>
    let filterButtonText = postType === 'alumni' ? 'Filter Alumni' : 'Filter';
    modalOpen = <div className='eight29-sidebar-toggle-wrapper'>
      {resultsElement}
      <button
        className="eight29-sidebar-toggle eight29-sidebar-open c-btn c-btn-secondary c-btn-color-normal"
        onClick={(e) => { toggleModal(e) }}
      >
        {filterButtonText}
      </button>
    </div>

    applyFilters = <div className="filter-action-buttons-wrapper">
      {reset}
      <button
        className="btn-filter-action btn-apply btn-trigger-header"
        onClick={(e) => { toggleModal(e) }}
      >Submit</button>
    </div>
  }

  if (displayResults) {
    totalResults = <li>
      <span>Posts ({results})</span>
    </li>
  }

  if (displaySearch && layout === 'default') {
    searchComponent = <FilterSearch
      filterReset={filterReset}
      currentSearchTerm={currentSearchTerm}

      searchFieldChange={searchFieldChange}
      setFilterReset={setFilterReset}
      setCurrentPage={setCurrentPage}
      setChangedFilter={setChangedFilter}
    ></FilterSearch>
  }

  if (displaySort && layout === 'default') {
    sortComponent = <FilterOrderBy
      order={order}
      orderChange={orderChange}
      setCurrentPage={setCurrentPage}
      setChangedFilter={setChangedFilter} 
    ></FilterOrderBy>
  }

  if (autoLoadFilters) {
    contentLeft = <div className="eight29-filter-list left-content">
      {filterList}
    </div>
  }
  else {
    contentLeft = <div className="eight29-filter-list left-content">
      {sidebarLeft}
    </div>
  }

  if (sidebarRight && layout !== 'default') {
    contentRight = <div className="eight29-filter-list right-content">
      {sidebarRight}
    </div>
  }

  if (layout === 'default' && (reset || totalResults)) {
    sidebarDetail = <ul className="eight29-sidebar-detail">
      {reset}
      {totalResults}
    </ul>
  }

  const content = <div className="eight29-filter-group">
    {searchComponent}
    {sortComponent}
    {contentLeft}
    {contentRight}
  </div>

  return (
    <form className={`eight29-sidebar ${modalActiveClass()} ${className}`}>
      {layout === 'programs' && <p>Filter by:</p>}
      <div className="eight29-sidebar-content">
        {modalTop}
        {sidebarDetail}
        {content}
        {applyFilters}
      </div>

      {modalOpen}
      {sidebarReset}
    </form>
  );
}

export default sidebar;